<template>
  <div style="text-align: center">
    <video ref="mediaRef" width="100%" controls v-if="type === 'video'"></video>
    <audio ref="mediaRef" width="100%" controls v-else></audio>
  </div>
</template>

<script>
import Hls from "hls.js";

export default {
  name: "HlsPlayer",
  props: {
    src: String,
    type: {
      type: String,
      default: "audio",
      validator: (val) => ["audio", "video"].includes(val),
    },
    play: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hls: new Hls(),
    };
  },
  mounted: function () {
    // this.hls.attachMedia(this.$refs['mediaRef']);
    // if(this.src) {
    //     this.hls.loadSource(this.src);
    // }
    this.prepareHls(false);
  },
  beforeDestroy: function () {
    if (this.hls) {
      this.hls.destroy();
    }
  },
  watch: {
    src(newSrc) {
      this.hls.loadSource(newSrc);
    },
    play(play) {
      if (play) {
        this.prepareHls(true);

        // this.$refs['mediaRef'].currentTime = 0;
        this.$refs["mediaRef"].play();
      } else {
        this.$refs["mediaRef"].pause();
      }
    },
  },
  methods: {
    prepareHls(load) {
      this.hls = new Hls({
        xhrSetup: (xhr, url) => {
          if (url.indexOf("key") != -1) {
            console.log("prepareHls()", this.getBearerToken());
            xhr.setRequestHeader(
              "Authorization",
              this.getBearerToken() 
             // "Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjQ4OTQ5ZDdkNDA3ZmVjOWIyYWM4ZDYzNWVjYmEwYjdhOTE0ZWQ4ZmIiLCJ0eXAiOiJKV1QifQ.eyJyb2xlcyI6WyJST0xFX0FETUlOIl0sIm9uQm9hcmRlZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6Ly9zZWN1cmV0b2tlbi5nb29nbGUuY29tL2RlYWYtZS1sZWFybmluZyIsImF1ZCI6ImRlYWYtZS1sZWFybmluZyIsImF1dGhfdGltZSI6MTYxNTU0Mjg1NiwidXNlcl9pZCI6Ik1rS25IVXRnUDJoSDc4UGZUSmVPSU9nNDZ6TzIiLCJzdWIiOiJNa0tuSFV0Z1AyaEg3OFBmVEplT0lPZzQ2ek8yIiwiaWF0IjoxNjE1NjE2ODg3LCJleHAiOjE2MTU2MjA0ODcsImVtYWlsIjoiYWRtaW5AZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsiYWRtaW5AZ21haWwuY29tIl19LCJzaWduX2luX3Byb3ZpZGVyIjoicGFzc3dvcmQifX0.kgUFNS22evgllunFKr46bjJAjXRxQGjnBNz0o0mCg0tr_KlQlaPbDIi7mXeR3myuv89XtJlSSrW83f52xpSD2QOtaqEQMxlKhARS9BE9kbRjw5_gH4lhtmimXLL0iZAu9S3EMYQgt8p_cCfR8emYZus7riaP3437RwHMPwxi9TkBF-IR0JvDjqvjJ99a77K2GZeQFtWtSWZGpUJPiUO7bJUB2qQAbiZ9f3RV0t5EObJfnr_yaoFzm2w-mMqtu0QmxLY8G_EI3MG0qgQoKWBYSa5a8xOdL44iSxyVO1zQcCfgm62W846wPBz8kSo1pnDH_A65nFvBKSg2rtD2-AD_MA"
            );
          }
        },

        loader: function (config) {
          let loader = new Hls.DefaultConfig.loader(config);

          this.abort = () => loader.abort();
          this.destroy = () => loader.destroy();
          this.load = (context, config, callbacks) => {
          
            let { url } = context;
          
            const regex = /.*api\/media\/secure\/.*\/hls\/key/g;
            if (regex.test(url)) {
              context.url = url.replace("api", "web/api");
              // context.url = 'https://aumhum-static.s3-us-west-2.amazonaws.com/t/MEDIA-f36548574a7b4859b2a1796e87a2b4e4.key';
            }
          //  console.log(`Manifest ${context.url} will be loaded.`);
            loader.load(context, config, callbacks);
          };
        },
      });
      this.hls.attachMedia(this.$refs["mediaRef"]);
      if (this.src && load) {
        this.hls.loadSource(this.findSafeUrl(this.src));
      }
    },
    findSafeUrl(url) {
      let proto = window.location.href.match(/https|http/);
      if (proto && proto[0] && proto[0] === "https") {
        return url.replace(/https|http/, "https");
      } else {
        return url;
      }
    },
  },
};
</script>